import React, { useState, useEffect } from "react";

import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import jwt from "jsonwebtoken";

const useStyles = makeStyles(dashboardStyle);

const PageNotFound = () => {

  return (
    <div style={{ textAlign: 'center', marginTop: '20vh' }}>
    <h1 style={{ fontSize: '3em', fontWeight: 'bold', color: '#555' }}>404 - Page Not Found</h1>
    <p style={{ fontSize: '1.5em', color: '#555' }}>Sorry, the page you are looking for might be unavailable or does not exist.</p>
    </div>
  );
};

export default PageNotFound;
